import React, { useState } from "react";
import ArticleList from "./article-list/ArticleList";
import ArticleBuilder from "./article-builder/ArticleBuilder";
import FullScreenDialog from "modules/swiftboard/components/ui/FullScreenDialog";

const KnowledgeArticle = ({ onTotalCountChange }) => {
  const [isBuilderOpen, setIsBuilderOpen] = useState(false);
  const [activeArticle, setActiveArticle] = useState(null);
  const [refreshSignal, setRefreshSignal] = useState(0);

  const openBuilder = (article = null) => {
    setActiveArticle(article);
    setIsBuilderOpen(true);
  };

  const closeBuilder = () => {
    setIsBuilderOpen(false);
    setActiveArticle(null);
    setRefreshSignal((prev) => prev + 1);
  };

  return (
    <div className="h-full overflow-hidden">
      <ArticleList onCreate={() => openBuilder(null)} onEdit={openBuilder} refreshSignal={refreshSignal} onTotalCountChange={onTotalCountChange} />

      <FullScreenDialog isOpen={isBuilderOpen} onClose={closeBuilder}>
        <ArticleBuilder article={activeArticle} onBack={closeBuilder} />
      </FullScreenDialog>
    </div>
  );
};

export default KnowledgeArticle;
